<template>

	<div class="page_content module_course" aria-label="Course Dashboard Page Content">

		<course-header :course-id="uuid" class="header_course_dashboard"></course-header>

		<div class="row page_content_container" :class="isTocOpen ? 'toc_activated' : ''">

			<!--
			<course-nav :course-id="uuid"></course-nav>
			-->

			<div class="row dasboard-left-section dashboard_container">
		      	<b-col cols="12" class="course-description">
    		        <b-row class="dashboard-row">

    		          <b-col cols="6" class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        <div class="card ace_sec" aria-label="Performance Section">
                            <div class="card-header">
                                <span class="icon float-left icon-meter text-center mr-2"></span>
                                <span class="label ace_sec_hd" role="heading" aria-level="1" aria-label="Performance summary">Performance</span>
                                <!--
                                <span class="float-right"><b-link class="ml-5 more-link" :to="{ name: 'classPerformance', params: {courseId: course.uuid}}">more</b-link></span>
                                -->
                            </div>
                            <div class="card-body performance-section">
                                <template v-if="course.master">
                                    <div class="no-data-master">
                                        <span class="ace_sec_txt">No Data in Master</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="performance-section-inner row">
                                        <div class="average-score-container col-4">
                                            <div class="head ace_sec_txt" aria-level="2">Average Score</div>
                                            <div class="grade-row">
                                                <template v-if="performanceAvg === 'N/A'">
                                                    <span class="current_score ace_sec_txt" :class="statusClass(performanceAvg)" :aria-label="performanceAvg" >
																											{{ performanceAvg }}%
																										</span>
                                                </template>
                                                <template v-else>
                                                    <span class="current_score ace_sec_txt" :class="statusClass(performanceAvg)" :aria-label="performanceAvg + '%'">
																											{{ performanceAvg }}%
																										</span>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="activity-graph-container col-8">
                                            <div class="graph-section">
                                            	<div class="graph ace_sec_txt">
                                                	<activity-bar-graph :activities="distributions" :yAxisLabel="'# of students'" class="graph-area graph-min-height"></activity-bar-graph>
    											</div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
    		          </b-col>

    		          <b-col cols="6" class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        <div class="card ace_sec" aria-label="Activity Section">
                            <div class="card-header">
                                                            <span class="ic_container">
                                                                <span class="ic icon-activity"></span>
                                                            </span>
                                                            <span class="label ace_sec_hd" role="heading" aria-level="5" aria-label="Activity summary">Activity</span>
                            </div>
                            <div class="card-body activity-section">
                                <template v-if="course.master">
                                    <div class="no-data-master">
                                        <span class="ace_sec_txt">No Data in Master</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="row mx-0 activity-graph-container">
                                        <div class="col-6 graph-section text-center">
                                            <activity-bar-graph :activities="learningActivities" class="graph ace_sec_txt"></activity-bar-graph>
                                            <div class="graph_label ace_sec_txt" :aria-label="learningActivityLabel">{{ learningActivityLabel }}</div>
                                        </div>
                                        <div class="col-6 graph-section text-center">
                                            <activity-bar-graph :activities="assessmentActivities" class="graph ace_sec_txt"></activity-bar-graph>
                                            <div class="graph_label ace_sec_txt" :aria-label="assessmentActivityLabel">{{ assessmentActivityLabel }}</div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>

    		          </b-col>
    		        </b-row>

    		        <b-row class="activity-row dashboard-row btm_row">

    		          <b-col cols="6" class="col-xl-6 col-lg-12 col-md-12 col-sm-12" v-if="course.showProgress">
                        <div class="card ace_sec" aria-label="Progress Section">
                            <div class="card-header">
                                <span class="icon float-left icon-progress text-center mr-2"></span>
                                <span class="label ace_sec_hd" role="heading" aria-level="3" aria-label="Progress summary">Progress</span>
                            </div>
                            <div class="card-body progress-section">
                                <template v-if="course.master">
                                    <div class="no-data-master">
                                        <span class="ace_sec_txt">No Data in Master</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="progress-section-inner">
                                        <div class="ml-4 ace_sec_txt" style="margin-bottom: 20px; font-size: 1.3rem;" role="heading" aria-level="4">Competencies</div>
                                        <div class="ml-4 progress-chart-conatiner ace_sec_txt">
                                            <competency-pace-bar :pace="pace" :is-student-view="false"></competency-pace-bar>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>

    		          </b-col>

    		          <b-col cols="6" class="col-xl-6 col-lg-12 col-md-12 col-sm-12" v-if="course.showAnnouncements">
                        <div class="card">
                              <div class="card-header">
                                <span class="icon float-left icon-channel text-center mr-2"></span>
                                <span class="label ace_sec_hd" role="heading" aria-level="6">Announcements</span>
                              </div>
                            <div class="card-body">
                                <template v-if="course.master">
                                    <div class="no-data-master">
                                        <span class="ace_sec_txt">No Data in Master</span>
                                    </div>
                                </template>
                                <!--
                                <div class="row mb-3 ml-2">
                                    <div class="thumbnail icon-admin float-left d-flex align-items-center justify-content-center mt-1"></div>
                                    <div class="announcement float-left ml-2">
                                        <div class="row admin">
                                            <small class="col-auto pr-2 red">Administrator</small>
                                            <small class="col-auto ml-2 time pl-0">7:23 PM</small>
                                        </div>
                                        <div class="row text">
                                            <span class="col-auto">Internship at Qualcom</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-3 ml-2">
                                    <div class="thumbnail icon-admin float-left d-flex align-items-center justify-content-center mt-1"></div>
                                    <div class="announcement float-left ml-2">
                                        <div class="row admin">
                                            <small class="col-auto pr-2 red">Administrator</small>
                                            <small class="col-auto ml-2 time pl-0">7:23 PM</small>
                                        </div>
                                        <div class="row text">
                                            <span class="col-auto">Internship at Illumina. There is only one space left. Ap…</span>
                                        </div>
                                    </div>
                                </div>
                                -->
                            </div>
                        </div>
                      </b-col>
    		        </b-row>
		        </b-col>
			</div>

		</div>

	</div>
</template>

<script>
import '../../../assets/module/css/course/courseDashboard.min.css'
import { mapState, mapActions } from 'vuex'
import CourseNav from './CourseNav'
import CourseHeader from './CourseHeader'
import CompetencyPaceBar from './CompetencyPaceBar'
import ActivityBarGraph from './ActivityBarGraph'

export default {
  name: 'courseDashboardInstructor',
  props: ['uuid'],
  components: {
    CourseNav,
    CourseHeader,
    CompetencyPaceBar,
    ActivityBarGraph
  },
  data: () => {
    return {
      learningActivityLabel: '',
      assessmentActivityLabel: '',
      pace: {idealPace: 0, classPace: 0, totalPace: 0},
      status_css: {
        10: 'noGrade',
        0: 'gradeE',
        1: 'gradeD',
        2: 'gradeC',
        3: 'gradeB',
        4: 'gradeA'
      }
    }
  },

  mounted () {
    if (this.isStudentLogin) {
      return this.$router.push({ name: 'courseDashboard', params: { uuid: this.uuid } })
    }
    this.loadCourse()
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadClassSummary'
    ]),

    loadCourse () {
      this.loadCourseDetail(this.uuid).then(response => {
        if (response && response.uuid) {
          this.loadClassSummary(this.uuid).then(res => {
            if (res) {
              this.pace.idealPace = res.idealPace
              this.pace.classPace = res.classPace
              this.pace.totalPace = res.totalPace
            }
          })
        }
      })
    },
    statusClass (performanceAvg) {
      var status = 10
      if (performanceAvg !== 'N/A') {
        if (performanceAvg >= 90) {
          status = 4
        } else if (performanceAvg >= 80 && performanceAvg < 90) {
          status = 3
        } else if (performanceAvg >= 65 && performanceAvg < 80) {
          status = 2
        } else if (performanceAvg >= 40 && performanceAvg < 65) {
          status = 1
        } else if (performanceAvg >= 0 && performanceAvg < 40) {
          status = 0
        }
      }
      return this.status_css[status]
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
			'isTocOpen': state => state.course.isTocOpen,
      'classSummary': state => state.course.classSummary
    }),

    isStudentLogin: function () {
      return (localStorage.getItem('userrole') === 'Student')
    },

    performanceAvg: function () {
      const classSummary = { ...this.classSummary }
      if (classSummary.uuid !== undefined) {
        const performance = classSummary.classPerformance
        return (performance.performanceAvg !== null) ? performance.performanceAvg.toFixed(2) : 'N/A'
      }
      return 'N/A'
    },

    distributions: function () {
      const classSummary = { ...this.classSummary }
      var activities = []
      if (classSummary.uuid !== undefined) {
        const performance = classSummary.classPerformance
        activities.push({name: '0-39', count: performance.zeroToForty, color: '#a01500'})
        activities.push({name: '40-64', count: performance.forutyToSixtyFive, color: '#ff8000'})
        activities.push({name: '65-79', count: performance.sixtyFiveToEighty, color: '#eec635'})
        activities.push({name: '80-89', count: performance.eightyToNinty, color: '#929000'})
        activities.push({name: '90-100', count: performance.nintyToHundred, color: '#008000'})
      }
      return activities
    },

    learningActivities: function () {
      const classSummary = { ...this.classSummary }
      var activities = []
      if (classSummary.uuid !== undefined) {
        var max = (classSummary.resourceMaxTimeTaken / 1000)
        var min = (classSummary.resourceMinTimeTaken / 1000)
        var avg = (classSummary.resourceAvgTimeTaken / 1000)
        if (max < 180) {
          this.learningActivityLabel = 'Learning Activity in Seconds'
        } else if (max > 180 && max < 10800) {
          this.learningActivityLabel = 'Learning Activity in Minutes'
          max = max / 60
          min = min / 60
          avg = avg / 60
        } else {
          this.learningActivityLabel = 'Learning Activity in Hours'
          max = max / 3600
          min = min / 3600
          avg = avg / 3600
        }
        activities.push({name: 'Max', count: max, color: '#005391'})
        activities.push({name: 'Min', count: min, color: '#005391'})
        activities.push({name: 'Avg', count: avg, color: '#005391'})
      }
      return activities
    },

    assessmentActivities: function () {
      const classSummary = { ...this.classSummary }
      var activities = []
      if (classSummary.uuid !== undefined) {
        var max = (classSummary.assessmentMaxTimeTaken / 1000)
        var min = (classSummary.assessmentMinTimeTaken / 1000)
        var avg = (classSummary.assessmentAvgTimeTaken / 1000)
        if (max < 180) {
          this.assessmentActivityLabel = 'Knowledge Check Activity in Seconds'
        } else if (max > 180 && max < 10800) {
          this.assessmentActivityLabel = 'Knowledge Check Activity in Minutes'
          max = max / 60
          min = min / 60
          avg = avg / 60
        } else {
          this.assessmentActivityLabel = 'Knowledge Check Activity in Hours'
          max = max / 3600
          min = min / 3600
          avg = avg / 3600
        }
        activities.push({name: 'Max', count: max, color: '#005391'})
        activities.push({name: 'Min', count: min, color: '#005391'})
        activities.push({name: 'Avg', count: avg, color: '#005391'})
      }
      return activities
    }
  }
}
</script>

<style scoped>
    .content {
      padding-top: 40px;
      margin-right: 30px;
      margin-left: 30px;
    }

    .course-description {
      padding-top:20px;
    }

    .activity-row {
      padding-top:20px;
      margin-bottom:20px;
    }

    .icon-progress {
        font-size: 41px !important;
        margin-top: -5px;
    }

    .icon-activity {
        font-size:42px!important;
    }

    .icon-announcements {
        font-size:34px !important;
    }

    .activity-graph-container {
        margin-top:7px;
		text-align:center;
    }

    .icon-channel  {
        font-size: 40px!important;
        margin-top: -3px;
    }

	.progress-section .progress-section-inner {
		height:146px;
	}

	.graph {
		padding-right:7px;
	}

	.more-link {
		font-size:18px;
	}

	.performance-section-inner {
		left:20px!important;
	}

	.no-data-master {
        height: 100%;
        font-size: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
	}
</style>



// WEBPACK FOOTER //
// src/app/course/components/CourseDashboardInstructor.vue